import { useQueryClient } from '@tanstack/react-query'
import { LoadingState } from '@cinesend/ui-kit'
import FieldValue from '../field_value'
import SettingsCard from '../settings_card'
import { isMediaField } from './field_groups'
import { useNonLocalizableFields } from './use_non_localizable_fields'

const MediaFields = ({ asset, cycleID }) => {
  const queryClient = useQueryClient()
  const { fields, cacheKeys, isLoading } = useNonLocalizableFields(asset.id, cycleID)
  const refreshValues = () => cacheKeys.forEach((key) => queryClient.invalidateQueries(key))

  if (isLoading) {
    return (
      <SettingsCard title='Media'>
        <LoadingState className='justify-center' />
      </SettingsCard>
    )
  }

  const visibleFields = fields.filter(({ field }) => isMediaField(field))
  if (visibleFields.length === 0) return null

  return (
    <SettingsCard title='Media' description='Video and audio fields for this asset.'>
      <div className='flex flex-col gap-6'>
        {visibleFields.map(({ field, cacheKey }) => (
          <div key={field.id} id={`field-${field.name?.toLowerCase()?.replaceAll(' ', '-')}`} className='w-full'>
            <FieldValue
              cacheKey={cacheKey}
              field={field}
              assetID={asset.id}
              cycleID={cycleID}
              refreshValues={refreshValues}
            />
          </div>
        ))}
      </div>
    </SettingsCard>
  )
}

export default MediaFields
